import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaFilePdf, FaArrowDown, FaTimes } from "react-icons/fa";
import One from '../Assets/Resume/1.jpg';
import Two from '../Assets/Resume/2.jpg';


const fadeIn = {
  hidden: { opacity: 0, y: 20 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
  exit: {
    opacity: 0,
    y: -20,
    transition: {
      duration: 0.3,
    },
  },
};

const Resume = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  return (
    <div id="resume" className="min-h-screen bg-black  flex flex-col items-center justify-center relative overflow-hidden">
      
      {/* Background Pattern */}
      <div className="absolute inset-0 grid grid-cols-8 opacity-5 pointer-events-none">
        {[...Array(64)].map((_, i) => (
          <div key={i} className="border-[0.5px] border-white/20" />
        ))}
      </div>

      {/* Main Content */}
      <motion.div
        initial="hidden"
        animate="show"
        variants={fadeIn}
        className="relative z-10 text-center"
      >
        <motion.h1
          className="text-4xl font-[rekind] mb-8 text-cyan-400"
          whileHover={{ scale: 1.05 }}
          transition={{ type: "spring", stiffness: 300 }}
        >
          Resume
        </motion.h1>

        <motion.div
          className="flex flex-col items-center gap-6"
          variants={fadeIn}
        >
          <motion.button
            onClick={() => setIsOpen(true)}
            className="group flex items-center gap-3 px-6 py-3 border border-white/20 rounded-full hover:border-cyan-400/40 transition-colors"
            whileHover={{ y: -3 }}
            whileTap={{ scale: 0.98 }}
          >
            <span className="text-lg">View Resume</span>
            <FaArrowDown className="group-hover:translate-y-1 transition-transform" />
          </motion.button>

          <a
            href="https://drive.google.com/file/d/12WWzC6y6fAK7RZ4VVJnv9LaKzVrWDCpx/view?usp=sharing"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-3 px-6 py-3 bg-white text-black rounded-full hover:bg-cyan-300 transition-colors"
          >
            <FaFilePdf />
            <span>Download PDF</span>
          </a>
        </motion.div>
      </motion.div>

      {/* Modal */}
      <AnimatePresence>
        {isOpen && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm"
          >
            <motion.div
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              className="relative w-full max-w-4xl bg-zinc-900 rounded-lg shadow-2xl"
            >
              {/* Modal Header */}
              <div className="flex items-center justify-between p-4 border-b border-white/10">
                <div className="flex items-center gap-4">
                  <button
                    onClick={() => setCurrentPage(1)}
                    className={`px-3 py-1 rounded ${
                      currentPage === 1 ? "bg-white text-black" : "text-white"
                    }`}
                  >
                    Page 1
                  </button>
                  <button
                    onClick={() => setCurrentPage(2)}
                    className={`px-3 py-1 rounded ${
                      currentPage === 2 ? "bg-white text-black" : "text-white"
                    }`}
                  >
                    Page 2
                  </button>
                </div>
                <button
                  onClick={() => setIsOpen(false)}
                  className="p-2 hover:bg-white/10 rounded-full transition-colors"
                >
                  <FaTimes />
                </button>
              </div>

              {/* Modal Content */}
              <div className="p-6 h-[80vh] overflow-y-auto">
                <AnimatePresence mode="wait">
                  <motion.img
                    key={currentPage}
                    src={currentPage === 1 ? One : Two} // Use variables directly without {}
                    alt={`Resume Page ${currentPage}`}
                    className="w-full h-auto"
                    initial={{ opacity: 0, x: 20 }}
                    animate={{ opacity: 1, x: 0 }}
                    exit={{ opacity: 0, x: -20 }}
                    transition={{ duration: 0.2 }}
                  />
                </AnimatePresence>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Resume;
